import WETHIcon from "../assets/img/common/WETH-icon.svg";
import DAIIcon from "../assets/img/common/DAI-icon.svg";
import USDTIcon from "../assets/img/common/USDT-icon.svg";
import USDCIcon from "../assets/img/common/USDC-icon.svg";
import MATICIcon from "../assets/img/common/MATIC-icon.svg";
import WMATICIcon from "../assets/img/common/WMATIC-icon.svg";
import ETHIcon from "../assets/img/common/ETH-icon.svg";
import BNBIcon from "../assets/img/common/BNB-icon.svg";
import WBNBIcon from "../assets/img/common/WBNB-icon.svg";
import DollarIcon from "../assets/img/common/dollar-icon.svg";
import OPIcon from "../assets/img/common/OP-icon.svg";
import ARBIcon from "../assets/img/common/ARB-icon.svg";
import USDGLOIcon from "../assets/img/common/glodollar.png";
import AXGTIcon from "../assets/img/common/AXGT-icon.png";
import CELOIcon from "../assets/img/common/CELO-icon.svg";

// Object containing currency icons mapped to their tickers
export const currencyIcons = {
  POL: MATICIcon,   // Polygon rebranded MATIC → POL
  MATIC: MATICIcon, // kept only for backward-compat display of old funded projects stored with currency="MATIC"
  ETH: ETHIcon,
  WETH: WETHIcon,
  BNB: BNBIcon,
  OP: OPIcon,
  ARB: ARBIcon,
  USDT: USDTIcon,
  USDC: USDCIcon,
  WBNB: WBNBIcon,
  WMATIC: WMATICIcon,
  DAI: DAIIcon,
  USD: DollarIcon,
  USDGLO: USDGLOIcon,
  AXGT: AXGTIcon,
  CELO: CELOIcon,
};

// Object containing currency configurations including name, native status, decimals, and chain-specific contract addresses
export const currencies = {
  // ---------- NATIVE TOKENS ---------- //

  CELO: {
    name: "CELO",
    isNativeToken: true,
    decimals: 18,
    chain: {
      celo: {
        contract: "0x0000000000000000000000000000000000000000",
      },
    },
  },

  BNB: {
    name: "BNB",
    isNativeToken: true,
    decimals: 18,
    chain: {
      bsc: {
        contract: "0x0000000000000000000000000000000000000000",
      },
    },
  },

  // Polygon native token – rebranded from MATIC to POL in 2024
  POL: {
    name: "POL",
    isNativeToken: true,
    decimals: 18,
    chain: {
      matic: {
        contract: "0x0000000000000000000000000000000000000000",
      },
    },
  },

  ETH: {
    name: "ETH",
    isNativeToken: true,
    decimals: 18,
    chain: {
      // goerli: {
      //   contract: "0x0000000000000000000000000000000000000000",
      // },
      ethereum: {
        contract: "0x0000000000000000000000000000000000000000",
      },
      arbitrum: {
        contract: "0x0000000000000000000000000000000000000000",
      },
      optimism: {
        contract: "0x0000000000000000000000000000000000000000",
      },
      sepolia: {
        contract: "0x0000000000000000000000000000000000000000",
      },
    },
  },

  // SEP: {
  //   name: "Sepolia Ether",
  //   isNativeToken: true,
  //   decimals: 18,
  //   chain: {
  //     sepolia: {
  //       contract: "0x0000000000000000000000000000000000000000",
  //     },
  //   },
  // },
  // ---------- ERC20 TOKENS ---------- //

  AXGT: {
    name: "AxonDAO Governance Token",
    isNativeToken: false,
    decimals: 18,
    chain: {
      ethereum: {
        contract: "0x6112C3509A8a787df576028450FebB3786A2274d",
      },
    },
  },
  USDGLO: {
    name: "Glo Dollar",
    isNativeToken: false,
    decimals: 18,
    chain: {
      ethereum: {
        contract: "0x4F604735c1cF31399C6E711D5962b2B3E0225AD3",
      },
      optimism: {
        contract: "0x4f604735c1cf31399c6e711d5962b2b3e0225ad3",
      },
      arbitrum: {
        contract: "0x4f604735c1cf31399c6e711d5962b2b3e0225ad3",
      },
      matic: {
        contract: "0x4F604735c1cF31399C6E711D5962b2B3E0225AD3",
      },
    },
  },
  OP: {
    name: "OP",
    isNativeToken: false,
    decimals: 18,
    chain: {
      optimism: {
        contract: "0x4200000000000000000000000000000000000042",
      },
    },
  },
  ARB: {
    name: "ARB",
    isNativeToken: false,
    decimals: 18,
    chain: {
      arbitrum: {
        contract: "0x912CE59144191C1204E64559FE8253a0e49E6548",
      },
    },
  },
  WETH: {
    name: "Wrapped Ether",
    isNativeToken: false,
    decimals: 18,
    chain: {
      ethereum: {
        contract: "",
      },
      ethereum_goerli: {
        contract: "", // "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
      },
      arbitrum_goerli: {
        contract: "",
      },
      // goerli: {
      //   contract: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
      // },
      ethereum: {
        contract: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
      },
    },
  },
  USDT: {
    name: "USDT",
    isNativeToken: false,
    decimals: 6,
    chain: {
      sepolia: {
        contract: "0xaA8E23Fb1079EA71e0a56F48a2aA51851D8433D0", // Sepolia USDT
      },
      arbitrum: {
        contract: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
      },
      // maticmum: {
      //   contract: "0x466dd1e48570faa2e7f69b75139813e4f8ef75c2",
      // },
      matic: {
        contract: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
      },
      // goerli: {
      //   contract: "0xb0f7554a44cc178e935ea10c79e7c042d1840044",
      // },
      ethereum: {
        contract: "0xdac17f958d2ee523a2206206994597c13d831ec7",
      },
      celo: {
        contract: "0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e",
      },
    },
  },
  USDC: {
    name: "USDC",
    isNativeToken: false,
    decimals: 6,
    chain: {
      sepolia: {
        contract: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238", // Sepolia USDC
      },
      arbitrum: {
        contract: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      },
      // maticmum: {
      //   contract: "0xd33602Ce228aDBc90625e4FC8071aAE0CAd11Fe9",
      // },
      matic: {
        contract: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
      },
      optimism: {
        contract: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
      },
      ethereum: {
        contract: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
      },
      celo: {
        contract: "0xcebA9300f2b948710d2653dD7B07f33A8B32118C",
      },
    },
  },

  DAI: {
    name: "DAI",
    isNativeToken: false,
    decimals: 18,
    chain: {
      sepolia: {
        contract: "0x68194a729C2450ad26072b3D33ADaCbcef39D574", // Sepolia DAI
      },
      ethereum: {
        contract: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      },
      arbitrum: {
        contract: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
      },
      optimism: {
        contract: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
      },
      matic: {
        contract: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
      },
    },
  },

  //  WBNB: {
  //     name: "BNB",
  //     decimals: 18,
  //     chain: {
  //       bnb: {
  //         contract: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
  //       },
  //     },
  //   },
  // WMATIC: {
  //   name: "Wrapped Matic",
  //   isNativeToken: false,
  //   decimals: 18,
  //   chain: {
  //     maticmum: {
  //       contract: "0x9c3c9283d3e44854697cd22d3faa240cfb032889",
  //     },
  //     matic: {
  //       contract: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
  //     },
  //   },
  // },
};

// Object containing contract addresses for different networks
export const contractNetworks = {
  // goerli: {
  //   crowdfunding: process.env.REACT_APP_GOERLI_CROWDFUNDING_CONTRACT_ADDRESS,
  //   marketplace: process.env.REACT_APP_GOERLI_MARKETPLACE_CONTRACT_ADDRESS,
  //   factory: process.env.REACT_APP_GOERLI_FACTORY_CONTRACT_ADDRESS,
  //   explorer: "https://goerli.etherscan.io",
  // },
  // maticmum: {
  //   crowdfunding: process.env.REACT_APP_MUMBAI_CROWDFUNDING_CONTRACT_ADDRESS,
  //   marketplace: process.env.REACT_APP_MUMBAI_MARKETPLACE_CONTRACT_ADDRESS,
  //   factory: process.env.REACT_APP_MUMBAI_FACTORY_CONTRACT_ADDRESS,
  //   explorer: "https://mumbai.polygonscan.com",
  // },
  matic: {
    fundrasingMinter:
      process.env.REACT_APP_POLYGON_FUNDRASINGMINTER_CONTRACT_ADDRESS,
    crowdfunding: process.env.REACT_APP_POLYGON_CROWDFUNDING_CONTRACT_ADDRESS,
    marketplace: process.env.REACT_APP_POLYGON_MARKETPLACE_CONTRACT_ADDRESS,
    factory: process.env.REACT_APP_POLYGON_FACTORY_CONTRACT_ADDRESS,
    communityFactory: process.env.REACT_APP_POLYGON_COMMUNITY_FACTORY_ADDRESS,
    explorer: "https://polygonscan.com",
  },
  bsc: {
    fundrasingMinter:
      process.env.REACT_APP_BSC_FUNDRASINGMINTER_CONTRACT_ADDRESS,
    crowdfunding: process.env.REACT_APP_BSC_CROWDFUNDING_CONTRACT_ADDRESS,
    marketplace: process.env.REACT_APP_BSC_MARKETPLACE_CONTRACT_ADDRESS,
    factory: process.env.REACT_APP_BSC_FACTORY_CONTRACT_ADDRESS,
    communityFactory: process.env.REACT_APP_BSC_COMMUNITY_FACTORY_ADDRESS,
    explorer: "https://bscscan.com",
  },
  bnb: {
    fundrasingMinter:
      process.env.REACT_APP_BSC_FUNDRASINGMINTER_CONTRACT_ADDRESS,
    crowdfunding: process.env.REACT_APP_BSC_CROWDFUNDING_CONTRACT_ADDRESS,
    marketplace: process.env.REACT_APP_BSC_MARKETPLACE_CONTRACT_ADDRESS,
    factory: process.env.REACT_APP_BSC_FACTORY_CONTRACT_ADDRESS,
    communityFactory: process.env.REACT_APP_BNB_COMMUNITY_FACTORY_ADDRESS,
    explorer: "https://bscscan.com",
  },
  sepolia: {
    fundrasingMinter:
      process.env.REACT_APP_SEPOLIA_FUNDRASINGMINTER_CONTRACT_ADDRESS,
    crowdfunding: process.env.REACT_APP_SEPOLIA_CROWDFUNDING_CONTRACT_ADDRESS,
    marketplace: process.env.REACT_APP_SEPOLIA_MARKETPLACE_CONTRACT_ADDRESS,
    factory: process.env.REACT_APP_SEPOLIA_FACTORY_CONTRACT_ADDRESS,
    communityFactory: process.env.REACT_APP_SEPOLIA_COMMUNITY_FACTORY_ADDRESS,
    explorer: "https://sepolia.etherscan.io",
  },
  arbitrum: {
    fundrasingMinter:
      process.env.REACT_APP_ARBITRUM_FUNDRASINGMINTER_CONTRACT_ADDRESS,
    crowdfunding: process.env.REACT_APP_ARBITRUM_CROWDFUNDING_CONTRACT_ADDRESS,
    marketplace: process.env.REACT_APP_ARBITRUM_MARKETPLACE_CONTRACT_ADDRESS,
    factory: process.env.REACT_APP_ARBITRUM_FACTORY_CONTRACT_ADDRESS,
    communityFactory: process.env.REACT_APP_ARBITRUM_COMMUNITY_FACTORY_ADDRESS,
    explorer: "https://arbiscan.io",
  },
  optimism: {
    fundrasingMinter:
      process.env.REACT_APP_OPTIMISM_FUNDRASINGMINTER_CONTRACT_ADDRESS,
    crowdfunding: process.env.REACT_APP_OPTIMISM_CROWDFUNDING_CONTRACT_ADDRESS,
    marketplace: process.env.REACT_APP_OPTIMISM_MARKETPLACE_CONTRACT_ADDRESS,
    factory: process.env.REACT_APP_OPTIMISM_FACTORY_CONTRACT_ADDRESS,
    communityFactory: process.env.REACT_APP_OPTIMISM_COMMUNITY_FACTORY_ADDRESS,
    explorer: "https://optimistic.etherscan.io",
  },
  ethereum: {
    fundraisingMinter:
      process.env.REACT_APP_ETHEREUM_FUNDRASINGMINTER_CONTRACT_ADDRESS,
    crowdfunding: process.env.REACT_APP_ETHEREUM_CROWDFUNDING_CONTRACT_ADDRESS,
    marketplace: process.env.REACT_APP_ETHEREUM_FACTORY_CONTRACT_ADDRESS,
    factory: process.env.REACT_APP_ETHEREUM_MARKETPLACE_CONTRACT_ADDRESS,
    communityFactory: process.env.REACT_APP_ETHEREUM_COMMUNITY_FACTORY_ADDRESS,
    explorer: "https://etherscan.io",
  },
  celo: {
    fundrasingMinter:
      process.env.REACT_APP_CELO_FUNDRASINGMINTER_CONTRACT_ADDRESS,
    crowdfunding: process.env.REACT_APP_CELO_CROWDFUNDING_CONTRACT_ADDRESS,
    factory: process.env.REACT_APP_CELO_FACTORY_CONTRACT_ADDRESS,
    marketplace: process.env.REACT_APP_CELO_MARKETPLACE_CONTRACT_ADDRESS,
    communityFactory: process.env.REACT_APP_CELO_COMMUNITY_FACTORY_ADDRESS,
    explorer: "https://celoscan.io",
  },
};

export const allChains = [
  {
    id: 56,
    name: "Binance Smart Chain",
    shortName: "BSC",
    ethersName: "bnb",
    network: "bsc",
    icon: BNBIcon,
  },
  {
    id: 137,
    name: "Polygon",
    shortName: "POL",
    ethersName: "matic",
    network: "matic",
    icon: MATICIcon,
  },
  // {
  //   id: 80001,
  //   name: "Polygon Mumbai",
  //   network: "maticmum",
  //   ethersName: "maticmum",
  // },
  {
    id: 11155111,
    name: "Ethereum Sepolia (Testnet)",
    shortName: "Sepolia",
    network: "sepolia",
    ethersName: "sepolia",
    icon: ETHIcon,
  },
  {
    id: 42161,
    name: "Arbitrum One",
    shortName: "ARB",
    network: "arbitrum",
    ethersName: "arbitrum",
    icon: ARBIcon,
  },
  {
    id: 10,
    name: "Optimism",
    shortName: "OP",
    network: "optimism",
    ethersName: "optimism",
    icon: OPIcon,
  },
  {
    id: 1,
    name: "Ethereum Mainnet",
    shortName: "ETH",
    network: "ethereum",
    ethersName: "ethereum",
    icon: ETHIcon,
  },
  {
    id: 42220,
    name: "Celo",
    shortName: "CELO",
    network: "celo",
    ethersName: "celo",
    icon: CELOIcon,
  },
];

// Function to retrieve currency configurations for a specific network
export function getNetworkCurrencies(network) {
  // Filter and map currencies based on the presence of contracts on the specified network
  const entries = Object.entries(currencies)
    .filter(([_, currency]) => currency.chain[network])
    .map(([ticker, currency]) => {
      const { chain, ...curr } = currency;
      return [ticker, { ...curr, info: chain[network] }];
    });
  return Object.fromEntries(entries);
}

// Function to retrieve configuration for a specific currency on a given network
export function getNetworkCurrency(network, ticker) {
  if (!network || !currencies[ticker]) {
    return null;
  }
  const { chain, decimals, ...curr } = currencies[ticker];
  if (!chain?.[network]) {
    return null;
  }
  return { ...curr, info: { ...chain?.[network], decimals } };
}

// Function to retrieve the native currency ticker for a specific network
export function getNativeCurrencyTicker(network) {
  const entry = Object.entries(currencies).find(([_, currency]) => {
    const contract = currency.chain?.[network]?.contract;
    return currency.isNativeToken && contract === "0x0000000000000000000000000000000000000000";
  });

  return entry?.[0] || "ETH";
}

// Function to retrieve a currency ticker from a token address on a specific network
export function getCurrencyTickerByAddress(network, tokenAddress) {
  if (!network || !tokenAddress) {
    return null;
  }

  const normalizedAddress = tokenAddress.toLowerCase();
  const zeroAddress = "0x0000000000000000000000000000000000000000";

  if (normalizedAddress === zeroAddress) {
    return getNativeCurrencyTicker(network);
  }

  const entry = Object.entries(currencies).find(([_, currency]) => {
    const contract = currency.chain?.[network]?.contract;
    return contract && contract.toLowerCase() === normalizedAddress;
  });

  return entry?.[0] || null;
}

// Function to retrieve all currency tickers
export function getCurrencyKeys() {
  return Object.keys(currencies);
}

// Function to retrieve currency tickers available on a specific network
export function getCurrencyKeysByNetwork(network) {
  return Object.keys(getNetworkCurrencies(network));
}

export function getChain({ chainId, network }) {
  if (chainId) {
    return allChains.find((chain) => chain.id === chainId);
  }
  if (network) {
    return allChains.find(
      (chain) => chain.network === network || chain.ethersName === network
    );
  }
}

// Function to retrieve all supported chains
export function getSupportedChains() {
  return allChains;
}
